export type ReportingOrder = {
  id: string
  type: string
  attributes: {
    order_platform_order_id: string
    customer_email: string
    customer_first_name: string
    customer_last_name: string
    customer_phone: string
    delivery_city: string
    delivery_fee: string
    delivery_state: string
    delivery_status: string | null
    delivery_street: string
    delivery_street2: string
    delivery_zip: string
    id: string
    internal_order_id: number
    order_status: string
    order_type: OrderType.pickup | OrderType.delivery
    platform_name: string
    pos_order_id: string | null
    submission_time: string
    subtotal: string
    tax: string
    tip: string
    payment_provider: PaymentProvider.square | PaymentProvider.stripe | null
    partner_id: string
    ready_at: string | null
    aasm_state: string | null
  }
}

export type Link = {
  first: string | null
  prev: string | null
  self: string | null
  next: string | null
  last: string | null
}

export type Meta = {
  limit: string
  page: number
  page_total: number
  total: number
}

export type OrderReportResponse = {
  data: ReportingOrder[]
  links: Link
  meta: Meta
}

export type ModalConfig = {
  title: (orderId: string) => string
  description: string
  submitText: string
  action: (orderId: number) => Promise<any>
}

export enum ModalType {
  cancel = 'cancel',
  refund = 'refund',
  ready_for_pickup = 'ready_for_pickup',
}

export enum OrderType {
  pickup = 'Pick-Up',
  delivery = 'Delivery',
}

export enum PaymentProvider {
  square = 'square',
  stripe = 'stripe',
}

export type OrderDetails = {
  id: string
  type: string
  attributes: {
    order_platform_order_id: string
    customer_email: string
    customer_first_name: string
    customer_last_name: string
    customer_phone: string
    delivery_city: string
    delivery_fee: number
    delivery_state: string
    delivery_status: string | null
    delivery_street: string
    delivery_street2: string
    delivery_zip: string
    id: number
    internal_order_id: number
    order_status: string
    order_type: OrderType.pickup | OrderType.delivery
    platform_name: string
    pos_ticket_id: string | null
    submission_time: string
    subtotal: number
    tax: number
    tip: number
    payment_provider: PaymentProvider.square | PaymentProvider.stripe | 'credit' | null
    partner_id: number
    completed_at: string | null
    aasm_state: string | null
    special_instructions: string | null
    future: string | null
    future_time: string | null
    placed_at: string | null
    order_items: Array<{
      id: string
      'menu-item-name': string
      quantity: string
      price: string
      'special-instructions': string
      'menu-choices': string
      'menu-choices-hash': Record<string, any>
      'customer-name': string | null
    }> | null
    payment_type: string | null
    total: number | null
    discount_amount: number | null
    pickup_info: string | null
    pos_order_id: string | null
    order_platform_id: number
    partner_name: string
    location_name: string
    platform_ticket_id: string
    created_at: string
    toos_payload?: Record<string, any> | null
    chowly_payload?: Record<string, any> | null
    mapping_payload?: Record<string, any> | null
    pos_payload?: Record<string, any> | null
    complete_payload?: Record<string, any> | null
    error_payload?: Record<string, any> | null
    service_fee_amount: number | null,
    total_without_service_fee: number | null,
    external_order_manager_url: string | undefined,
  }
}

export type DeliveryIncluded = {
  id: string;
  type: string;
  attributes: {
    job_id?: string;
    dispatch_service_id?: string;
    order_id?: string;
    iframe_url?: string;
  };
};

export type PaymentProviderIncluded = {
  id: string;
  type: string;
  attributes: {
    kind: string | null;
    active: boolean;
  };
};